'use client';

import { ColumnsType } from 'antd/es/table';
import {
  InputMaybe,
  Payment,
  PaymentPage,
  PaymentSortAttributeEnum,
  SortOrderEnum
} from 'gql/graphql';
import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useContext } from 'react';
import { Control } from 'react-hook-form';
import useSearchParamsPayments, { FiltersPaymentsForm } from './useSearchParamsPayments';
import useTablePayments from './useTablePayments';
type TPaymentsContext = {
  payments?: PaymentPage;
  isLoading: boolean;
  isPending: boolean;
  isRetrieving: boolean;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  totalPages: number;
  handleClear: () => void;
  control: Control<FiltersPaymentsForm>;
  filtersAdded: boolean;
  columns: ColumnsType<Payment>;
  sortAttribute?: InputMaybe<PaymentSortAttributeEnum>;
  sortOrder?: InputMaybe<SortOrderEnum>;
};

const initialState = {
  isLoading: false,
  isPending: false,
  isRetrieving: false,
  page: 1,
  setPage: () => {},
  totalPages: 0,
  handleClear: () => {},
  control: {} as Control<FiltersPaymentsForm>,
  filtersAdded: false,
  columns: [],
  sortAttribute: undefined,
  sortOrder: undefined
};

const PaymentsContext = createContext<TPaymentsContext>(initialState);

const usePaymentsContext = (): TPaymentsContext => useContext(PaymentsContext);

const PaymentsProvider: FC<PropsWithChildren<unknown>> = ({ children }): JSX.Element => {
  const {
    isLoading,
    isPending,
    page,
    setPage,
    totalPages,
    payments,
    isRetrieving,
    control,
    filtersAdded,
    handleClear,
    sortAttribute,
    sortOrder
  } = useSearchParamsPayments();

  const { columns } = useTablePayments();

  return (
    <PaymentsContext.Provider
      value={{
        payments,
        isLoading,
        isPending,
        isRetrieving,
        page,
        setPage,
        totalPages,
        handleClear,
        control,
        filtersAdded,
        columns,
        sortAttribute,
        sortOrder
      }}
    >
      {children}
    </PaymentsContext.Provider>
  );
};

export { PaymentsProvider, usePaymentsContext };
